import SingleTickIcon from './SingleTickIcon';
export default SingleTickIcon;
